import { get, patch } from "./api";

const accountSettingsService = {
  fetchAccount: (accountId) => get({ endpoint: `/account-settings/${accountId}` }),
  fetchSftpSettings: (accountId) => get({ endpoint: `/account-settings/${accountId}/sftp/settings` }),
  editAccount: (accountId, data) => patch({ endpoint: `/account-settings/${accountId}`, data }),
  fetchSubscription: (accountId) => get({ endpoint: `/account-settings/${accountId}/salesforce/subscription` }),
  fetchSubscriptionUsageOverTime: (accountId) =>
    get({ endpoint: `/account-settings/${accountId}/salesforce/subscription/usage-over-time` })
};

export default accountSettingsService;
